__webpack_require__.p = "https://v2-terminal.apps.qorcommerce.io/";